module.exports = __webpack_public_path__ + "static/formations-live-995d56c9efb6eed705a1813df526e786.png";